import React from 'react';
import ZoneIntervention from '../components/ZoneIntervention';
import { ZONES_SEO } from '../seo/pagesSeo';

function Zone94() {
    const seo = ZONES_SEO['94'];
     const cities = [
        "Antiquaire Ablon-sur-Seine (94480)",
        "Antiquaire Alfortville (94140)",
        "Antiquaire Arcueil (94110)",

        "Antiquaire Boissy-Saint-Léger (94470)",
        "Antiquaire Bonneuil-sur-Marne (94380)",
        "Antiquaire Bry-sur-Marne (94360)",

        "Antiquaire Cachan (94230)",
        "Antiquaire Champigny-sur-Marne (94500)",
        "Antiquaire Charenton-le-Pont (94220)",
        "Antiquaire Chennevières-sur-Marne (94430)",
        "Antiquaire Chevilly-Larue (94550)",
        "Antiquaire Choisy-le-Roi (94600)",
        "Antiquaire Créteil (94000)",

        "Antiquaire Fontenay-sous-Bois (94120)",
        "Antiquaire Fresnes (94260)",

        "Antiquaire Gentilly (94250)",

        "Antiquaire Ivry-sur-Seine (94200)",

        "Antiquaire Joinville-le-Pont (94340)",

        "Antiquaire L’Haÿ-les-Roses (94240)",
        "Antiquaire La Queue-en-Brie (94510)",
        "Antiquaire Le Kremlin-Bicêtre (94270)",
        "Antiquaire Le Perreux-sur-Marne (94170)",
        "Antiquaire Le Plessis-Trévise (94420)",
        "Antiquaire Limeil-Brévannes (94450)",

        "Antiquaire Maisons-Alfort (94700)",
        "Antiquaire Mandres-les-Roses (94520)",
        "Antiquaire Marolles-en-Brie (94440)",

        "Antiquaire Nogent-sur-Marne (94130)",
        "Antiquaire Noiseau (94880)",

        "Antiquaire Orly (94310)",
        "Antiquaire Ormesson-sur-Marne (94490)",

        "Antiquaire Périgny (94520)",

        "Antiquaire Rungis (94150)",

        "Antiquaire Saint-Mandé (94160)",
        "Antiquaire Saint-Maur-des-Fossés (94100)",
        "Antiquaire Saint-Maurice (94410)",
        "Antiquaire Santeny (94440)",
        "Antiquaire Sucy-en-Brie (94370)",

        "Antiquaire Thiais (94320)",
        "Antiquaire Valenton (94460)",
        "Antiquaire Villecresnes (94440)",
        "Antiquaire Villejuif (94800)",
        "Antiquaire Villeneuve-le-Roi (94290)",
        "Antiquaire Villeneuve-Saint-Georges (94190)",
        "Antiquaire Villiers-sur-Marne (94350)",
        "Antiquaire Vincennes (94300)",
        "Antiquaire Vitry-sur-Seine (94400)"
    ];
    return <ZoneIntervention departmentName="Val-de-Marne (94)" cities={cities} seoTitle={seo.title} seoDescription={seo.description} seoPath={seo.path} />;
}

export default Zone94;
